import { render, staticRenderFns } from "./fankui.vue?vue&type=template&id=f6a69eec&scoped=true&"
import script from "./fankui.vue?vue&type=script&lang=js&"
export * from "./fankui.vue?vue&type=script&lang=js&"
import style0 from "./fankui.vue?vue&type=style&index=0&id=f6a69eec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a69eec",
  null
  
)

export default component.exports